import React from 'react';
import PropTypes from 'prop-types';
import CorrectIcon from '@learningblocks/exp-constants/lib/Images/correct-icon.svg';
import IncorrectIcon from '@learningblocks/exp-constants/lib/Images/incorrect-icon.svg';
import {Image} from '@learningblocks/storybook-components';

const ANSWER_INCORRECT = 'incorrect answer';
const ANSWER_CORRECT = 'correct anser';

/**
 * FooterFeedback
 *  - The component that displays the feedback for Question in footer
 */
export function FooterFeedback({showFeedback, isCorrect}) {
  if (showFeedback) {
    let src = IncorrectIcon;
    let alt = ANSWER_INCORRECT;
    if (isCorrect) {
      src = CorrectIcon;
      alt = ANSWER_CORRECT;
    }
    return <Image className="feedback-icon" src={src} alt={alt} />;
  } else {
    return null;
  }
}

FooterFeedback.propTypes = {
  /**
   * Boolean value to display/hide the feedback
   */
  showFeedback: PropTypes.bool.isRequired,
  /**
   * Boolean specifying if submitted answer correct.
   */
  isCorrect: PropTypes.bool.isRequired,
};
